<template>
  <v-row class="h-100p pa-5">
    <v-snackbar top color="success" v-model="showUploadSuccess" :timeout="3000">
      {{ $t("uploadSuccess") }}
    </v-snackbar>
    <add-screenshot-dialog
      v-if="showAddScreenshotDialog"
      :screenshot="screenshotToAdd"
      :faceRecStatus="faceRecStatus"
      :faceRecStatusTemp="faceRecStatusTemp"
      :faceRecValue="faceRecValue"
      :isOBAFExisting="capturedScreenshots.some(screenshot => screenshot.value === 'OBAF')"
      :isProcessAvailableForFaceRecognition="isProcessAvailableForFaceRecognition"
      :nfcStatus="nfcStatus"
      @onCancel="onScreenshotAddCanceled"
      @onAdded="onScreenshotAdded"
      @onClickFaceRecognition="calculateFaceRecognitionMatch"/>

    <v-col :cols="showCustomerCard ? 8 : 12" style="padding-right: 60px">
      <jitsi-meeting
        @selectAllScreenshots="selectAllScreenshots"
        v-if="renderJitsi"
        :roomName="roomName"
        :tckn="tckn"
        :leadPartyId="leadPartyId"
        :primaryContactType="primaryContactType"
        :allListItems="allListItems"
        :screenshotCount="capturedScreenshots.filter(item => item.checked).length"
        @onClickToggleCustomerCard="onClickToggleCustomerCard"
        @onScreenshotCaptured="onScreenshotCaptured"
        @onClickUploadScreenshots="uploadScreenshots"
        @onAllScreenshotsDeleted="onAllCapturedScreenshotDeleted"
        @showCustomerCardOpen="showCustomerCardOpen"
        :imagesUploaded="imagesUploaded"
        :faceRecStatus="faceRecStatus"
        :faceRecValue="faceRecValue"
        :imagesUploading="imagesUploading"
        :addressApproved="addressApproved"
        @setProcessAvailableForFaceRecognition="setProcessAvailableForFaceRecognition"
        @setIsContractListEnabled="setIsContractListEnabled"
        @setContractInfoList="setContractInfoList"
        @setProcessVariablesList="setProcessVariablesList"
        @setVideoOtpEnabled="setVideoOtpEnabled"/>
      <v-progress-linear
        v-if="imagesUploading"
        v-model="screenshotPercentage"
        height="20">
        <strong>
          {{ screenshotLoaded + " / " + checkedScreenshots.length }}
        </strong>
      </v-progress-linear>
      <div class="carousel-wrapper" v-if="capturedScreenshots.length">
        <Carousel
          :capturedScreenshots="capturedScreenshots"
          @onDeleted="onCapturedScreenshotDeleted"
        />
      </div>
    </v-col>
    <v-col v-if="userCardCreate":cols="showCustomerCard ? 4 : 12" class="customer-card-wrapper mb-5">
      <tab-holder
         ref= "tabholder"
         :tckn = "tckn"
         :leadPartyId = "leadPartyId"
         :checkListItems = "checkListItems"
         :isContractListEnabled = "isContractListEnabled"
         :contractInfoList = "contractInfoList"
         :processVariablesList = "processVariablesList"
         @setNfcStatus = "setNfcStatusAction"/>
    </v-col>
  </v-row>
</template>

<script>

import VideoConversation from "./mixin/VideoConversation";

export default {
  mixins: [VideoConversation]
};
</script>
<style lang="scss" scoped>
.carousel-wrapper {
  position: relative;
  margin-bottom: 5%;
  background-color: #474747;
  padding: 2% 5%;
}
.check-all-btn {
  
  position: absolute;
  bottom: -20px;
  right: -40px;
}
.h-100p {
  height: 100%;
}
.customer-card-wrapper {
  margin-bottom: 100px;
}
</style>


// WEBPACK FOOTER //
// src/pages/videoconversation/VideoConversation.vue